const {
    protocol, host, origin
} = window.location;
export default {
    hostLogin: `${origin}/apiuc`,
    timeout: 10000,
    MOCK: false
}
